export const seoConfig = {
  siteName: 'Calculations.Space',
  siteUrl: 'https://calculations.space',
  title: 'Calculations.Space - Cosmic & Numerological Analysis',
  description: 'Explore the hidden patterns of the universe through advanced numerological calculations, sacred geometry, and cosmic correspondences.',
  keywords: [
    'numerology',
    'sacred geometry',
    'gematria',
    'pythagorean numerology',
    'chaldean numerology',
    'vedic astrology',
    'bazi calculator',
    'cosmic calculations',
    'esoteric mathematics',
    'sacred numbers',
    'mystical calculations'
  ],
  author: 'Calculations.Space',
  
  // Open Graph
  og: {
    type: 'website',
    locale: 'en_US',
    image: '/og-image.png',
    imageWidth: 1200,
    imageHeight: 630,
  },
  
  // Twitter Card
  twitter: {
    handle: '@calculations',
    site: '@calculations',
    cardType: 'summary_large_image',
    image: '/twitter-card.png',
  },
  
  // Structured Data
  structuredData: {
    '@context': 'https://schema.org',
    '@type': 'WebApplication',
    name: 'Calculations.Space',
    description: 'Advanced numerological and cosmic calculation tools',
    url: 'https://calculations.space',
    applicationCategory: 'UtilityApplication',
    operatingSystem: 'Any',
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'USD',
    },
    creator: {
      '@type': 'Organization',
      name: 'Calculations.Space',
      url: 'https://calculations.space',
    },
  },
};